import React, { Fragment, useEffect, useState } from "react";
import n8n from "../../assets/utils/images/Intagration image/n8n.png";
import requestApiService from "../../services/requestApi.service";
import { confirmBox, loadConnectedIntegration } from "../../Common/Appcommon";
import { cardData } from "./Constants";
import ShowIntegrationInfo from "./ShowIntDetails.js";

const N8N = (props) => {
    let { install, installedButton, buttonValue, name } = props;
    const [isConnected, setConnectionStatus] = useState(false);
    const [carddata, setData] = useState(cardData);
    const [accountInfo, setAccountInfo] = useState([]);
    let key = '';
    let foundData = carddata.find((data) => data.name === "n8n");
    if (foundData) {
        key = foundData.component.button.key;
    }
    let integrationData = [];
    const [tabInfo, setTabInfo] = useState([]);
    useEffect(() => {
        (async () => {
            if(install === true){
                onInstallN8N();
            }
            await fetchGoogleAccountDetails();
        })();
        return () => {
            // this now gets called when the component unmounts
        };
    }, [install]);

    const fetchGoogleAccountDetails = async () => {
        let integrationInfo = await loadConnectedIntegration(name); //'gcalendar'
        if (integrationInfo.length > 0) {
            setConnectionStatus(true);
            let connectedInfo = integrationInfo[0][2];
            connectedInfo = JSON.parse(connectedInfo);
            let token = connectedInfo['token']['access_token'];
            let reftoken = connectedInfo['token']['refresh_token'];
            let IntegrationAccountInfo = [
                { type: "id", id: integrationInfo[0][0] },
                { type: "text", label: "Token", value: token },
                { type: "text", label: "Refresh Token", value: reftoken },
            ];
            setAccountInfo(IntegrationAccountInfo);
        } else {
            integrationData = [];
            setConnectionStatus(false);
            setTabInfo([]);
        }

    };


    const onInstallN8N = async (e) => {
        window.open("https://n8n.io/integrations/webhook/", '_blank');
        /* let appHost = window.location.hostname;
        let protocol = window.location.protocol;
        let callback = protocol + "//" + appHost + "/#/oauth/callback";
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "GET_OAUTH_URL",
            NAME: "N8N",
            CALLBACK: callback
        }
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            let authUrl = response.data;
            window.parent.location.href = authUrl;
        } */
    }

    const removeIntegration = async (e, integrationId) => {
        let confirm = await confirmBox("Are you sure want to Uninstall " + integrationHeadData.name + "?", "Uninstalling the " + integrationHeadData.name + " app all actions linked to it will stop working.", 'warning', 'Uninstall', 'Cancel');
        if (!confirm) {
            return;
        }
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "REMOVE_INTEGRATION",
            ID: integrationId
        }
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            // installedButton();
            // setintegrationId('');
            await fetchGoogleAccountDetails();
        }
    }

    /* const getSimpleTabs = () => {
        return tabInfo.map(({ name, biography }, index) => ({
            key: index,
            title: name,
            getContent: () => biography, // Render function if it's a component
        }));
    } */


    const integrationHeadData = {
        name: "N8N",
        tag: "Automation",
        image: n8n,
        installButtonText: "Install App",
        uninstallButtonText: "Uninstall App",
    };

    const integrationContent = [
        { heading: "Website", subheading: "https://n8n.io", type: "url" },
        { heading: "Overview", subheading: "Connect your AI Voice Agent with n8n, an open-source automation platform, to build powerful custom workflows across your favorite apps and services. Automate lead management, data syncing, and calendar updates with complete control and flexibility.", type: "text" },
        { heading: "Key Benefits", 
            subheading: [
                { 
                    description: "Build tailored automation workflows without coding." 
                },
                { 
                    description: "Seamlessly integrate with CRMs, Google Sheets, calendars, and more" 
                },
                { 
                    description: "Automate lead creation, updates, and tagging via webhook triggers" 
                },
                { 
                    description: "Sync call outcomes and lead data bi-directionally" 
                },
                { 
                    description: "Connect calendar tools like Calendly for appointment scheduling and management" 
                },
                { 
                    description: "Full control over data flow with open-source transparency" 
                },], type: "list" },
        { heading: "How It Works", 
            subheading: [
                { 
                    title: "Create/Update Leads (via Webhooks)",
                    description: "Trigger workflows when new calls occur or leads update. Automatically create or update lead records, assign tags or lists, and modify fields using webhook-driven automation." 
                },
                { 
                    title: "Sync Data Across Tools (via Custom Actions)", 
                    description: "Fetch and update lead information in your CRM, Google Sheets, or other apps, keeping all systems aligned before and after calls." 
                },
                { 
                    title: "Calendar Automation (via Custom Actions)", 
                    description: "Check availability, and book, reschedule, or cancel appointments using calendar tools like Calendly—all managed through n8n workflows connected to your AI Voice Agent." 
                },
        ], type: "list" }
        
    ];


    return (
        <Fragment>
            <div className="agent-details">
                <ShowIntegrationInfo
                    keyname={name}
                    headData={integrationHeadData}
                    integrationData={integrationContent}
                    isInstalled={buttonValue.includes(name)}
                    isConnected={isConnected}
                    accountInfo={accountInfo}
                    onInstall={onInstallN8N}
                    onRemove={removeIntegration}
                />
            </div>
        </Fragment>
    );


}

export default N8N;
